import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {TextInput, DatePicker, Checkbox, Button, Select} from 'advenio-components'
import {Form} from 'formsy-react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import AddSiblingActions from '../../Data/Redux/AddSiblingRedux'
import {isEmpty, isNil} from "ramda";

const Container = styled.div`
  width: 700px;
  height: 500px;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`
const Parents = styled.div`
  flex: 1;
  margin-right: 5px;
  margin-left: 5px;
  display: flex;
  justify-content: ${({right}) => right ? 'flex-start' : 'center'};
  align-items: center;
  flex-direction: row;
`
const Row = styled.div`
  width: 100%;
  height: 115px;
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  flex-direction: ${({column}) => column && 'column'};
`
const Input = styled.div`
  flex: 1;
  margin-right: 5px;
  margin-left: 5px;
  display: flex;
  justify-content: ${({left}) => left ? 'flex-end' : 'center'};
  align-items: ${({left}) => left ? 'flex-end' : 'center'};;
  flex-direction: row;
`

class AddSibling extends Component {
  state = {
    options: [],
    showParents: true,
    selectedCenter: null,
    pctSiblings: 0
  }

  componentWillMount() {
    const {centers, enrolledSibling} = this.props

    if (centers.length <= 0) return false

    const data = []

    centers.forEach((center) => {
      data.push({
        id: center.id,
        value: center.id,
        label: `${center.name} (${center.abbreviation})`,
      })
    })

    const selectedCenter = centers.find(center => center.name === enrolledSibling.center.name)

    if (enrolledSibling) {
      let siblings = 1
      if (enrolledSibling.siblings.length > 0) {
        siblings = siblings + enrolledSibling.siblings.length
      }
      this.setState({pctSiblings: siblings})
    }

    return this.setState({options: data, selectedCenter})
  }

  getParents = () => this.props.parents.map((parent, index) => (
    <Parents key={parent.id} right>
      <Checkbox
        name={`parent_${parent.id}`}
        label={`${parent.first_name} ${parent.last_name_paternal}`}
        invertedColors
        hideEmptyHelpBlock
        value
      />
    </Parents>
  ))

  submit = (data) => {
    const {addSibling, enrolledSibling, parents, products} = this.props
    const parentsToSend = []

    Object.keys(data).filter(key => key.includes('parent'))
      .map((key) => {
        const selectedParent = parents.find(parent => parent.id == key.split('_')[1])

        return selectedParent && parentsToSend.push(selectedParent.userable_id)
      })

    let product = enrolledSibling.product

    if (isEmpty(product) || isNil(product)) {
      product = {...products[0], type: "CenterProduct"}

    }

    const params = {
      first_name: data.name,
      last_name_paternal: data.last_name_paternal,
      last_name_maternal: data.last_name_maternal,
      birth_date: data.birth_date,
      center_of_interest: data.center,
      finalize_enrollment: data.finalize_enrollment,
      custom_tuition_fee: this.state.pctSiblings * 10,
      support_as_pct: true,
      contractable_type: "Advenio\\Models\\" + product.type,
      contractable_id: product.id,
    }

    if (data.finalize_enrollment) {
      params.parents = parentsToSend
    }

    addSibling(enrolledSibling.id, params)
  }

  render() {
    const {
      closeModal,
      enrolledSibling,
      loading,
    } = this.props
    const {
      options,
      selectedCenter,
      showParents,
    } = this.state


    return (
      <Container>
        <Form style={{width: '100%'}} onChange={this.onChange} onSubmit={this.submit}>
          <Row>
            <Input>
              <TextInput
                name="name"
                label="Nombre"
              />
            </Input>
            <Input>
              <TextInput
                name="last_name_paternal"
                label="Apellido paterno"
                value={enrolledSibling.last_name_paternal}
              />
            </Input>
            <Input>
              <TextInput
                name="last_name_maternal"
                label="Apellido materno"
                value={enrolledSibling.last_name_maternal}
              />
            </Input>
          </Row>
          <Row>
            <Input>
              <DatePicker
                name="birth_date"
                label="Fecha de nacimiento"
              />
            </Input>
            <Input>
              <Select
                name="center"
                label="Centro de interés"
                options={options}
                value={selectedCenter && selectedCenter.id}
              />
            </Input>
            <Input>
              <Checkbox
                name="finalize_enrollment"
                label="Finalizar Inscripción"
                value
                invertedColors
                hideEmptyHelpBlock
              />
            </Input>
          </Row>
          {showParents ?
            <Row column>
              <span>Tutores del hermano</span>
              {this.getParents()}
            </Row> :
            <Row/>
          }
          <Row>
            <Input left>
              <Button onClick={closeModal} marginRight="0">
                Cancelar
              </Button>
              <Button primary type="submit" loading={loading} marginRight="0">
                Guardar
              </Button>
            </Input>
          </Row>
        </Form>
      </Container>
    )
  }
}

AddSibling.propTypes = {
  /** Array of available Advenio centers */
  centers: PropTypes.array.isRequired,
  /** The student/sibling who is already enrolled */
  enrolledSibling: PropTypes.object.isRequired,
  /** Loading flag */
  loading: PropTypes.bool,
  /** Array of parents who can be associated with the sibling */
  parents: PropTypes.array.isRequired,
  /** Callback function to be fired after closing the modal */
  closeModal: PropTypes.func.isRequired,
  /** Attempt to store the sibling in the API */
  addSibling: PropTypes.func.isRequired,
}

AddSibling.defaultProps = {
  loading: false,
}

const mapStateToProps = state => ({
  centers: state.centerOptions.get.results,
  products: state.center_products.get.results
})

const mapDispatchToProps = dispatch => ({
  addSibling: (studentId, data) => dispatch(AddSiblingActions.addSiblingRequest(studentId, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddSibling)



// WEBPACK FOOTER //
// ./src/Components/ModalContainer/AddSibling.jsx